import React from "react";

function ChatList({ children, empty }) {
  if (empty) {
    return (
      <div className="flex-grow-1 d-flex align-items-center justify-content-center text-muted">
        No chats found
      </div>
    );
  }

  return (
    <div className="chat-list flex-grow-1 overflow-auto">
      {children}
    </div>
  );
}


export default ChatList;